import { Box, CircularProgress } from '@mui/material';
import { FunctionComponent } from 'react';

export const Loading: FunctionComponent<{}> = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', height: 200 }}>
      <CircularProgress />
    </Box>
  );
};
